(function () {
  'use strict';

  var PHASE_ATTRIBUTE = 'data-kjs-card-phase';
  var PHASE_VALUE = '8';
  var REQUEST_TIMEOUT = 12000;
  var ROOT_MARGIN = '1200px 0px';
  var SEARCH_START_DELAY = 350;
  var MAX_DUPLICATE_PAGES = 4;
  var ACTIVE_CLASS = 'kjs-catalog-autoload--active';
  var INITIALIZED_ATTRIBUTE = 'data-kjs-catalog-autoload';
  var states = [];

  var surfaces = [
    {
      name: 'collection-grid',
      rootSelector: '.template-collection #content .collection-grid',
      itemSelector: '.element'
    },
    {
      name: 'collection-list',
      rootSelector: '.template-collection #content .collection-view-list',
      itemSelector: '.collection-list'
    },
    {
      name: 'native-search',
      rootSelector: '.template-search #content .kjs-search-results-panel .search-infinite-wrapper',
      itemSelector: 'div'
    }
  ];

  function isPhase8() {
    return document.body &&
      document.body.getAttribute(PHASE_ATTRIBUTE) === PHASE_VALUE;
  }

  function supportsProgressiveLoading() {
    return 'IntersectionObserver' in window &&
      'fetch' in window &&
      'Promise' in window &&
      'DOMParser' in window &&
      'URL' in window;
  }

  function directItems(root, selector) {
    return Array.prototype.filter.call(root && root.children || [], function (child) {
      return child.nodeType === 1 && child.matches && child.matches(selector);
    });
  }

  function owningProductContainer(root) {
    return root && root.closest ? root.closest('.product_c') : null;
  }

  function paginationFor(root) {
    var container = owningProductContainer(root);
    var paginations;
    var index;

    if (!container) return null;
    paginations = container.querySelectorAll('.kjs-pagination');
    for (index = 0; index < paginations.length; index += 1) {
      if (paginations[index].closest('.product_c') === container) return paginations[index];
    }
    return null;
  }

  function safeNextUrl(pagination) {
    var link = pagination && pagination.querySelector(
      'a.kjs-pagination__control--next[rel="next"], a[rel="next"]'
    );
    var url;

    if (!link || !link.getAttribute('href')) return '';
    try {
      url = new URL(link.getAttribute('href'), window.location.href);
      if (url.origin !== window.location.origin) return '';
      return url.toString();
    } catch (error) {
      return '';
    }
  }

  function productKey(item) {
    var card = item && item.querySelector && item.querySelector('.kjs-product-card');
    var handle = card && card.getAttribute('data-kjs-search-handle');
    var productLink;
    var match;
    var badge;

    if (handle) return 'handle:' + String(handle).toLowerCase();
    productLink = item && item.querySelector && item.querySelector('a[href*="/products/"]');
    if (productLink) {
      try {
        match = new URL(productLink.getAttribute('href'), window.location.origin)
          .pathname.match(/\/products\/([^/?#]+)/i);
      } catch (error) {
        match = null;
      }
      if (match) return 'handle:' + decodeURIComponent(match[1]).toLowerCase();
    }
    badge = item && item.querySelector && item.querySelector('[data-id]');
    return badge && badge.getAttribute('data-id') ?
      'id:' + badge.getAttribute('data-id') : '';
  }

  function rememberExistingProducts(state) {
    directItems(state.root, state.surface.itemSelector).forEach(function (item) {
      var key = productKey(item);
      if (key) state.productKeys[key] = true;
    });
  }

  function setBusy(state, busy) {
    state.loading = busy;
    state.root.setAttribute('aria-busy', busy ? 'true' : 'false');
    state.sentinel.classList.toggle('is-loading', busy);
    if (busy) {
      state.sentinel.hidden = false;
      state.sentinel.textContent = 'Loading more products…';
    }
  }

  function clearProgressListener(state) {
    if (!state.progressListener) return;
    window.removeEventListener('scroll', state.progressListener);
    state.progressListener = null;
  }

  function replacePagination(state, sourcePagination) {
    var imported;

    if (!sourcePagination) {
      state.nextUrl = '';
      return;
    }
    imported = document.importNode(sourcePagination, true);
    state.pagination.parentNode.replaceChild(imported, state.pagination);
    state.pagination = imported;
    state.nextUrl = safeNextUrl(imported);
  }

  function refreshLoadedProducts(items) {
    try {
      if (window.lazySizes && window.lazySizes.loader &&
          typeof window.lazySizes.loader.checkElems === 'function') {
        window.lazySizes.loader.checkElems();
      }
    } catch (error) {
      /* Product images still have normal src attributes. */
    }

    try {
      if (typeof window.enabledQuickViewAfterScroll === 'function') {
        window.enabledQuickViewAfterScroll();
      }
    } catch (error) {
      /* Quick view is optional and must not break catalogue loading. */
    }

    try {
      document.dispatchEvent(new CustomEvent('kjs:catalog:products-appended', {
        detail: { items: items }
      }));
    } catch (error) {
      /* CustomEvent support is not required for the cards themselves. */
    }
  }

  function revealPaginationFallback(state, message) {
    if (state.observer) state.observer.disconnect();
    clearProgressListener(state);
    state.failed = true;
    state.paused = true;
    state.loading = false;
    state.root.removeAttribute('aria-busy');
    state.container.classList.remove(ACTIVE_CLASS);
    state.sentinel.hidden = false;
    state.sentinel.classList.remove('is-loading', 'is-complete');
    state.sentinel.classList.add('is-error');
    state.sentinel.textContent = message ||
      'Automatic loading stopped. Use the page links below to continue.';
  }

  function markComplete(state) {
    if (state.observer) state.observer.disconnect();
    clearProgressListener(state);
    state.complete = true;
    state.loading = false;
    state.root.removeAttribute('aria-busy');
    state.sentinel.hidden = false;
    state.sentinel.classList.remove('is-loading', 'is-error');
    state.sentinel.classList.add('is-complete');
    state.sentinel.textContent = 'All products loaded.';
  }

  function fetchDocument(url, state) {
    var controller = 'AbortController' in window ? new AbortController() : null;
    var request;
    var timeout;
    var timer;

    state.requestController = controller;
    request = fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error('Catalogue page request failed: ' + response.status);
      return response.text();
    }).then(function (html) {
      return new DOMParser().parseFromString(html, 'text/html');
    });

    timeout = new Promise(function (resolve, reject) {
      timer = window.setTimeout(function () {
        var timeoutError = new Error('Catalogue page request timed out.');
        timeoutError.name = 'TimeoutError';
        reject(timeoutError);
        if (controller) controller.abort();
      }, REQUEST_TIMEOUT);
    });

    return Promise.race([request, timeout]).then(function (page) {
      window.clearTimeout(timer);
      state.requestController = null;
      return page;
    }).catch(function (error) {
      window.clearTimeout(timer);
      state.requestController = null;
      throw error;
    });
  }

  function observe(state) {
    clearProgressListener(state);
    if (!state.observer || state.paused || state.failed || state.complete ||
        state.loading || !state.nextUrl) return;
    state.sentinel.hidden = false;
    state.observer.observe(state.sentinel);
  }

  function observeAfterUserProgress(state) {
    var startY;

    if (!state.observer || state.paused || state.failed || state.complete ||
        state.loading || !state.nextUrl || state.progressListener) return;
    startY = window.pageYOffset || document.documentElement.scrollTop || 0;
    state.progressListener = function () {
      var currentY = window.pageYOffset || document.documentElement.scrollTop || 0;

      if (Math.abs(currentY - startY) < 16) return;
      clearProgressListener(state);
      observe(state);
    };
    window.addEventListener('scroll', state.progressListener, { passive: true });
  }

  function appendPage(state, page) {
    var sourceRoot = page.querySelector(state.surface.rootSelector);
    var sourcePagination;
    var sourceItems;
    var importedItems = [];
    var fragment = document.createDocumentFragment();

    if (!sourceRoot) throw new Error('The next product grid was not returned.');
    sourceItems = directItems(sourceRoot, state.surface.itemSelector);
    if (!sourceItems.length) throw new Error('The next product page contained no products.');
    sourcePagination = paginationFor(sourceRoot);

    sourceItems.forEach(function (sourceItem, index) {
      var key = productKey(sourceItem);
      var imported;

      if (key && state.productKeys[key]) return;
      imported = document.importNode(sourceItem, true);
      if (key) state.productKeys[key] = true;
      else imported.setAttribute('data-kjs-autoload-source-index', String(index));
      fragment.appendChild(imported);
      importedItems.push(imported);
    });

    state.root.appendChild(fragment);
    replacePagination(state, sourcePagination);
    return importedItems;
  }

  function loadNextPage(state) {
    var requestUrl = state.nextUrl;

    if (!requestUrl || state.loading || state.paused || state.failed || state.complete) return;
    if (state.requestedUrls[requestUrl]) {
      revealPaginationFallback(
        state,
        'Automatic loading stopped to avoid repeating a page. Use the page links below to continue.'
      );
      return;
    }

    state.requestedUrls[requestUrl] = true;
    if (state.observer) state.observer.unobserve(state.sentinel);
    setBusy(state, true);

    fetchDocument(requestUrl, state).then(function (page) {
      var importedItems = appendPage(state, page);

      setBusy(state, false);
      refreshLoadedProducts(importedItems);

      if (!importedItems.length) {
        state.duplicatePages += 1;
        if (state.nextUrl && state.duplicatePages <= MAX_DUPLICATE_PAGES) {
          state.sentinel.textContent = 'Checking the next product page…';
          window.setTimeout(function () { loadNextPage(state); }, 0);
          return;
        }
        if (state.nextUrl) {
          revealPaginationFallback(
            state,
            'Automatic loading stopped after repeated products. Use the page links below to continue.'
          );
          return;
        }
      } else {
        state.duplicatePages = 0;
      }

      if (!state.nextUrl) {
        markComplete(state);
        return;
      }

      state.sentinel.textContent = importedItems.length +
        (importedItems.length === 1 ? ' more product loaded.' : ' more products loaded.');
      /* Requiring continued user progress prevents the browser's scroll
       * anchoring from keeping the sentinel intersecting and cascading
       * through the entire catalogue after a single trip to the bottom. */
      observeAfterUserProgress(state);
    }).catch(function (error) {
      if (state.leavingPage) return;
      revealPaginationFallback(state);
    });
  }

  function createSentinel() {
    var sentinel = document.createElement('div');
    sentinel.className = 'kjs-catalog-autoload__sentinel';
    sentinel.setAttribute('role', 'status');
    sentinel.setAttribute('aria-live', 'polite');
    sentinel.setAttribute('aria-atomic', 'true');
    sentinel.hidden = true;
    return sentinel;
  }

  function createState(root, surface) {
    var container;
    var pagination;
    var nextUrl;
    var sentinel;
    var state;

    if (root.hasAttribute(INITIALIZED_ATTRIBUTE)) return null;
    container = owningProductContainer(root);
    pagination = paginationFor(root);
    nextUrl = safeNextUrl(pagination);
    if (!container || !pagination || !nextUrl) return null;

    sentinel = createSentinel();
    pagination.parentNode.insertBefore(sentinel, pagination);
    state = {
      surface: surface,
      root: root,
      container: container,
      pagination: pagination,
      sentinel: sentinel,
      nextUrl: nextUrl,
      observer: null,
      progressListener: null,
      requestController: null,
      requestedUrls: Object.create(null),
      productKeys: Object.create(null),
      duplicatePages: 0,
      loading: false,
      paused: surface.name === 'native-search',
      externallyPaused: false,
      startTimer: null,
      failed: false,
      complete: false,
      leavingPage: false
    };

    rememberExistingProducts(state);
    try {
      state.observer = new IntersectionObserver(function (entries) {
        var shouldLoad = entries.some(function (entry) { return entry.isIntersecting; });
        if (shouldLoad) loadNextPage(state);
      }, {
        root: null,
        rootMargin: ROOT_MARGIN,
        threshold: 0
      });
    } catch (error) {
      sentinel.remove();
      return null;
    }

    root.setAttribute(INITIALIZED_ATTRIBUTE, surface.name);
    container.classList.add(ACTIVE_CLASS);
    states.push(state);
    if (state.paused) {
      /* The prefix-first search controller starts on the same event turn and
       * pauses this native/fuzzy grid while direct matches load. A short
       * grace period prevents the two observers from racing. */
      state.startTimer = window.setTimeout(function () {
        state.startTimer = null;
        if (state.externallyPaused) return;
        state.paused = false;
        observe(state);
      }, SEARCH_START_DELAY);
    } else {
      observe(state);
    }
    return state;
  }

  function stateForElement(element) {
    var index;
    if (!element) return null;
    for (index = 0; index < states.length; index += 1) {
      if (states[index].root === element || states[index].root.contains(element) ||
          element.contains && element.contains(states[index].root)) {
        return states[index];
      }
    }
    return null;
  }

  function pauseForElement(element) {
    var state = stateForElement(element);
    if (!state || state.failed || state.complete) return false;
    window.clearTimeout(state.startTimer);
    state.startTimer = null;
    clearProgressListener(state);
    state.externallyPaused = true;
    state.paused = true;
    if (state.observer) state.observer.unobserve(state.sentinel);
    state.sentinel.hidden = true;
    return true;
  }

  function resumeForElement(element) {
    var state = stateForElement(element);
    if (!state || state.failed || state.complete) return false;
    window.clearTimeout(state.startTimer);
    state.startTimer = null;
    state.externallyPaused = false;
    state.paused = false;
    observe(state);
    return true;
  }

  function initialize() {
    if (!isPhase8() || !supportsProgressiveLoading()) return;
    surfaces.forEach(function (surface) {
      Array.prototype.forEach.call(
        document.querySelectorAll(surface.rootSelector),
        function (root) { createState(root, surface); }
      );
    });
  }

  window.KjsCatalogAutoload = {
    pauseForElement: pauseForElement,
    resumeForElement: resumeForElement,
    refresh: initialize
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  window.addEventListener('pagehide', function (event) {
    states.forEach(function (state) {
      clearProgressListener(state);
      if (event.persisted) {
        if (state.observer) state.observer.unobserve(state.sentinel);
        return;
      }
      state.leavingPage = true;
      if (state.requestController) state.requestController.abort();
      if (state.observer) state.observer.disconnect();
    });
  });

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    states.forEach(function (state) { observe(state); });
  });
}());

